import React from 'react';
import JsonEditor from '../JsonEditor';

// For the deeply nested kinds (definitions, action defaults): the JSON itself, in the V3 JSON editor. The API still checks it and answers in words.
export default function JsonField({ field, value, onChange }) {
  return <JsonEditor value={value || ''} onChange={onChange} label={field.label} hint={field.help} />;
}
